import { useEffect, useState } from 'react';
import { OutboxState, getOutboxState, subscribeOutbox, startOutboxFlusher } from '../lib/outbox';

/**
 * useOutbox — subscribe to outbox + connection state.
 *
 * Auto-starts the background flusher on first mount. Re-renders the
 * caller whenever:
 *   - online/offline toggles
 *   - a queued write is added
 *   - a queued write is sent
 *   - a sync run starts/ends
 */
export function useOutbox() {
  const [state, setState] = useState<OutboxState>(getOutboxState());
  useEffect(() => {
    startOutboxFlusher();
    return subscribeOutbox(setState);
  }, []);
  return state;
}
